import { Button } from '@shared/Button';
import styles from './AdwantagesFooter.module.scss';
import { Checkbox } from '@shared/Checkbox';
import { Typography } from '@shared/Typography';
import { Loading } from '@shared/Loading';

type Props = {
  onStart: () => void;
  dontShowAgain: boolean;
  setDontShowAgain: (value: boolean) => void;
  showButtons?: boolean;
};

export const AdwantagesFooter = ({
  onStart,
  dontShowAgain,
  setDontShowAgain,
  showButtons,
}: Props) => {
  return (
    <>
      <div className={styles.ahFooterWrapper}>
        <div className={styles.ahFooterImage}>
          <img
            className={styles.ahTicketImage}
            src="/images/Advantages/AdwantagesPassport-v2.webp"
            width={300}
            height={320}
            alt="ticket"
          />
        </div>

        {!showButtons && (
          <div className={styles.loadingWrapper}>
            <Loading />
            <Typography component="h2" className={styles.terms}>
              ALSI-202506002 FI1
            </Typography>
          </div>
        )}

        {showButtons && (
          <div className={styles.options}>
            <div className={styles.buttonWrapper}>
              <Button
                variant="custom"
                title="Start"
                className={styles.startButton}
                onClick={onStart}
                customButtonWidth={96}
                customButtonHeight={36}
              />
              <Typography component="description" className={styles.terms}>
                ALSI-202506002 FI1
              </Typography>
            </div>
            <Checkbox
              checked={dontShowAgain}
              setChecked={setDontShowAgain}
              checkboxText="Don't show again"
              className={styles.checkbox}
            />
          </div>
        )}
      </div>
    </>
  );
};
